import { useMutation } from '@tanstack/react-query';
import { sendPasswordResetEmail, fetchSignInMethodsForEmail } from 'firebase/auth';
import { auth } from 'src/config/firebase';
import { IAuthResetPasswordPayload } from '../interfaces/auth';

export function useAuthResetPassword() {
  return useMutation({
    mutationFn: async (payload: IAuthResetPasswordPayload) => {
      const { email } = payload;

      // Check if the user exists first
      const methods = await fetchSignInMethodsForEmail(auth, email);
      if (methods.length === 0) {
        throw new Error('auth/user-not-found');
      }

      const basePath = process.env.APP_BASENAME || '';
      await sendPasswordResetEmail(auth, email, {
        url: `${window.location.origin}${basePath}/onboarding-trainer/login?type=trainer`,
      });
    },
  });
}
